import { NgModule, InjectionToken, ModuleWithProviders } from '@angular/core';

import { SvgIconComponent } from '@/app/shared/components/ui/svg-icon';

export const SVG_SPRITE_URL = new InjectionToken('SVG_SPRITE_URL');

@NgModule({
  imports: [SvgIconComponent],
  exports: [SvgIconComponent],
})
export class SvgIconModule {
  static forRoot(config?: { spriteUrl?: string }): ModuleWithProviders<SvgIconModule> {
    return {
      ngModule: SvgIconModule,
      providers: [{ provide: SVG_SPRITE_URL, useValue: config?.spriteUrl }],
    };
  }
}
